import React, { useState } from "react";
import { Button, Input } from "@speedoc/design-assets";
import { Redirect } from "react-router-dom";
import { useLocation } from "react-router-dom";
import URI from "urijs";

export default function PrivateLogin() {
  const [isOpen, setIsOpen] = useState(
    localStorage.getItem("speedoc-private-login-pwd") === process.env.REACT_APP_LOGIN_KEY
  );
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const handlePasswordSubmit = e => {
    if (e.target.password.value === process.env.REACT_APP_LOGIN_KEY) {
      localStorage.setItem("speedoc-private-login-pwd", e.target.password.value);
      setIsOpen(true);
    } else {
      setFeedbackMessage("Invalid password...");
    }
    e.preventDefault();
  };

  const lastPath = new URI(useLocation().search).search(true).redirect;
  if (isOpen) return <Redirect to={{ pathname: lastPath }} />;

  return (
    <div id="privateLogin">
      <div className="content">
        <form onSubmit={handlePasswordSubmit}>
          <Input type="password" required name="password" placeholder="Preview password" />
          <Button type="submit" aria-label="private login submit button">
            Enter
          </Button>
        </form>
        <div className="feedback">{feedbackMessage ? <p>{feedbackMessage}</p> : null}</div>
      </div>
    </div>
  );
}
